import { useEffect, useState } from 'react';
import { fetchWasteBills } from '../api/waste-bills';

export function useWasteBills() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;

        fetchWasteBills()
            .then((result) => { if (!cancelled) setData(result); })
            .catch((err) => { if (!cancelled) setError(err); })
            .finally(() => { if (!cancelled) setLoading(false); });

        return () => { cancelled = true; };
        
    }, []);

    return { data, loading, error };
}